import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { ThemeService } from '@core/services/theme/theme.service';
import { TuiStringHandler } from '@taiga-ui/cdk';
import { TuiDataListWrapper, TuiSelect, TuiChevron } from '@taiga-ui/kit';
import { FormsModule } from '@angular/forms';
import {
  TuiSizeL,
  TuiSizeS,
  TuiIcon,
  TuiDropdown,
  TuiTextfield,
  TuiLabel,
} from '@taiga-ui/core';
import { TranslatePipe } from '@ngx-translate/core';

interface ThemeOption {
  name: string;
  value: 'light' | 'dark' | 'system';
  icon: string;
}

@Component({
  selector: 'x-theme-selector',
  imports: [
    TuiLabel,
    TuiTextfield,
    TuiChevron,
    TuiSelect,
    FormsModule,
    TuiDataListWrapper,
    TuiIcon,
    TranslatePipe,
    TuiDropdown,
  ],
  templateUrl: './theme-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSelectorComponent implements OnInit {
  readonly themeOptions: ThemeOption[] = [
    {
      name: 'as_system',
      value: 'system',
      icon: '@tui.refresh-cw',
    },
    {
      name: 'light',
      value: 'light',
      icon: '@tui.sun',
    },
    {
      name: 'dark',
      value: 'dark',
      icon: '@tui.moon',
    },
  ];

  $size = input<TuiSizeL | TuiSizeS>('m', {
    alias: 'size',
  });

  readonly stringifyThemeOptions: TuiStringHandler<ThemeOption> = option =>
    option.name;

  currentTheme: ThemeOption = this.themeOptions[0];

  readonly themeService = inject(ThemeService);

  ngOnInit() {
    const storedTheme = this.themeOptions.find(
      option => option.value === this.themeService.getStored(),
    );

    this.currentTheme = storedTheme || this.themeOptions[0];
  }

  setTheme(theme: ThemeOption) {
    this.currentTheme = theme;
    this.themeService.setTheme(theme.value);
  }
}
